export default class Modal {
  constructor(object) {
    try {
      this.map(object)
    } catch(e) {
      console.warn('Invalid Type: ModelModal')
    }
  }

  map(object) {
    // 表示するモーダルコンポーネント
    this.component = object.component
    // モーダルコンポーネントにわたすprops
    this.props = object.props || null
  }
}
